import { ValidationRule } from "react-hook-form";

/**
 * The length rules.
 */
export interface LengthRules {
  /**
   * The minimum length validation rule.
   */
  readonly minLength?: ValidationRule<number>;

  /**
   * The maximum length validation rule.
   */
  readonly maxLength?: ValidationRule<number>;
}

/**
 * The disabled length rule.
 */
export const DisabledLengthRule: LengthRules = {
  minLength: undefined,
  maxLength: undefined,
};

/**
 * Gets a range length validation rule.
 * @param min The minimum length to validate or undefined if no length specified.
 * @param max The maximum length to validate or undefined if no length specified.
 * @returns The validation rules.
 */
export function length(min: number | undefined, max: number | undefined): LengthRules {
  let result: LengthRules = DisabledLengthRule;

  if (min !== undefined) {
    result = {
      ...result,
      minLength: {
        value: min,
        message:
          max === undefined ? `Must be ${min} or more character${min === 1 ? "" : "s"}` : `Must be between ${min} and ${max} characters`,
      },
    };
  }

  if (max !== undefined) {
    result = {
      ...result,
      maxLength: {
        value: max,
        message:
          min === undefined ? "Exceeds character limit" : `Must be between ${min} and ${max} characters`,
      },
    };
  }

  return result;
}
